import React, { useEffect, useState } from "react";
import styles from './partList.module.css';
import {

  Paper,
  Typography,
  Box,


} from "@mui/material";
import { Close, Payment, Refresh } from "../../../Svg";
import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { styled } from '@mui/material/styles';
import { scheduleDetailsThunk, setscheduleData, updateProductFromScheduleThunk } from "../../../redux/schedulecartslice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fomateDate } from "../../../utils/fomateDate";
import api from "../../../utils/api";
import { toast } from "react-toastify";



const EditScheduleEnq = () => {

  const { loading, refresh, orderDetails } = useSelector((state) => state.schedule);
  const [updateLoading, setUpdateLoading] = useState(false)
  const [products, setProducts] = useState([])
  const navigate = useNavigate()
  const { id } = useParams()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(scheduleDetailsThunk(id))
  }, [refresh])


  const handleQuantityChange = (productId, newQuantity) => {
    const updatedProducts = products?.map((product) => {
      if (product.productId === productId) {
        const parsedQuantity = parseInt(newQuantity, 10) || 0;
        return { ...product, quantity: parsedQuantity };
      }
      return product;
    });
    // dispatch(setscheduleData(updatedProducts));
    setProducts(updatedProducts)
  };

  const handlePriceChange = (productId, newPrice) => {
    const updatedProducts = products?.map((product) => {
      if (product.productId === productId) {
        const price = newPrice || 0;

        return { ...product, unitPrice: price }
      }

      return product;
    })

    setProducts(updatedProducts);
  }


  const handleDeleteProduct = (productId) => {
    const updatedProducts = orderDetails?.products?.filter(
      (product) => product.productId !== productId
    );
    // dispatch(setscheduleData(updatedProducts));
    setProducts(updatedProducts)
  };


  const handleTotalQuantityChange = (productId, newQuantity) => {
    const updatedProducts = products?.map((product) => {
      if (product?.productId === productId) {
        const parsedQuantity = parseInt(newQuantity, 10) || 0;
        return { ...product, totalQty: parsedQuantity };
      }
      return product;
    });
    // dispatch(setscheduleData(updatedProducts));
    setProducts(updatedProducts)
  };


  const handleRefresh = (id) => {
    const previousData = orderDetails?.products?.find((i) => i?.productId === id)
    const refresh = products?.map((i) => {
      if (i?.productId === id) {
        return { ...i, quantity: previousData?.quantity, totalQty: previousData?.totalQty, unitPrice: previousData?.unitPrice }
      }
      return i
    })
    setProducts(refresh)

  }



  const editProduct = async () => {

    const product = products?.map((i) => (
      {
        productId: i?.productId,
        quantity: i?.quantity,
        totalQty: i?.totalQty,
        unitPrice: i?.unitPrice
      }
    ))

    const data = {
      id,
      products: product
    }

    setUpdateLoading(true)

    try {
      const res = await api.updateScheduleEnquiryProduct(data)

      if (res.status === 200) {

        const status = await dispatch(updateProductFromScheduleThunk(data))
        setUpdateLoading(false)
        if (status?.payload === 200) {
          navigate(-1)
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong")
    }

  }

  useEffect(() => {
    setProducts(orderDetails?.products)
  }, [orderDetails])


  return (
    <>
      <NestedUserHeader
        index="Edit Scheduling details"
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />

      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              {orderDetails?.products?.length} Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: {fomateDate(orderDetails?.createdAt)}
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "400", color: orderDetails?.status === "NEW" ? '#727A90' : orderDetails?.status === "APPROVED" ? '#1A9882' : '#E9BD21' }}>
              {orderDetails?.status}
            </Typography>
          </Box>

        </Box>

        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture Part #</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Required Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Schedule quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>Unit Price</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>Sub total</th>
              </tr>
            </thead>
            <tbody>
              {products?.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>{index + 1}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item?.productDetails?.productOverview?.productNumber[0]}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item?.productDetails?.productOverview?.manufacturer[0]?.name}</td>

                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter"
                      className={styles.addCatInput}
                      value={item?.totalQty}
                      id={`total-quantity-${item?.productId}`}
                      onChange={(e) =>
                        handleTotalQuantityChange(item?.productId, e.target.value)
                      }
                    />
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter"
                      className={styles.addCatInput}
                      value={item?.quantity}
                      id={`quantity-${item?.productId}`}
                      onChange={(e) =>
                        handleQuantityChange(item?.productId, e.target.value)
                      }
                    />
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>

                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Price"
                      className={styles.addCatInput}
                      value={item?.unitPrice}
                      id={`price-${item?.productId}`}
                      onChange={(e) =>
                        handlePriceChange(item?.productId, e.target.value)
                      }
                    />
                    {/* {item?.unitPrice} */}
                  </td>

                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>
                    <div className={styles.closetd}>
                      <div>
                        {(item?.totalQty * item?.unitPrice)?.toFixed(2)}
                      </div>
                      <div style={{ display: "flex", gap: "20px", padding: '0px 20px' }}>
                        <div onClick={() => handleRefresh(item?.productId)}>

                          <Refresh />
                        </div>
                        <div onClick={() => handleDeleteProduct(item?.productId)}>
                          <Close />
                        </div>
                      </div>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>


          <div className={styles.displayFlex}>
            <button className={styles.cancelBtn} onClick={() => dispatch(scheduleDetailsThunk(id))}>Cancel</button>
            <button className={styles.submitBtn} onClick={editProduct}>{updateLoading ? 'please wait...' : "Approve & submit"}</button>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default EditScheduleEnq;
